import { AccessRights } from 'src/app/features/role/user-role/user-role'

import { BsModalService } from 'ngx-bootstrap/modal'
import { Observable, of, Subject } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'

import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'

import { RolePermissions } from '../role-permissions'
import { rolePermissionsActions } from '../role-permission.actions'
import { rolePermissionsSelectors } from '../role-permissions.selectors'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  take
} from 'rxjs/operators'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy'
import { RolePermissionsService } from '../role-permissions.service'
import { environment } from 'src/environments/environment'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { NavItemType } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-constants'
import { GenericMainWrapperModalComponent } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal.component'
import { getNavItems } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-utils'
@UntilDestroy()
@Component({
  selector: 'role-permissions-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class RolePermissionsIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  // public rolePermissions$: Observable<RolePermissions[]>
  public rolePermissions$: Subject<RolePermissions[]> = new Subject<
    RolePermissions[]
  >()
  public BulkAction = BulkAction
  public onClickCreateTile$: Subject<boolean> = new Subject()
  public form: UntypedFormGroup
  public accessRights = AccessRights
  public total: number = 0
  public page: number = 1
  public limit: number = 25
  public order: any = 'ASC'
  public field: string = 'id'
  public pageCount: number = 0
  public removeSearchTerm$: Subject<boolean> = new Subject<boolean>()
  public searchTerm$ = new Subject<string>()
  public searchTerm
  public hideCreateRoleButton: boolean
  public rolePermissionsModuleConfig =
    environment.moduleConfigs.rolePermissionsModule
  private URL_BASE = '/role-permissions'
  constructor(
    private modalService: BsModalService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private actions$: Actions,
    private notificationService: NotificationService,
    private rolePermissionsService: RolePermissionsService
  ) {}

  ngOnInit() {
    const navigationEntries = performance.getEntriesByType(
      'navigation'
    ) as PerformanceNavigationTiming[]
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'back_forward' &&
      navigationEntries[0].name.includes('(modal:') &&
      this.route.outlet == 'primary'
    ) {
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'reload'
    ) {
      //hard Refresh
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    this.form = this.fb.group({
      selectedType: ['role-permissions', []]
    })

    this.isLoading$ = this.store.select(
      rolePermissionsSelectors.selectIsLoading
    )
    if (this.form.controls.selectedType.value == 'role-permissions') {
      this.fetchRolePermissions()
    }
    this.searchTerm$
      .pipe(distinctUntilChanged(), debounceTime(5), untilDestroyed(this))
      .subscribe((term) => {
        this.searchTerm = term
        this.page = 1
        this.fetchRolePermissions()
      })

    this.actions$
      .pipe(
        untilDestroyed(this),
        ofType(rolePermissionsActions.upsertMany),
        catchError((error) => of(null))
      )
      .subscribe((action: any) => {
        if (!action) {
          return
        }
        if (this.router.url != this.URL_BASE) return
        this.total = action?.total
        this.pageCount = action?.pageCount

        this.rolePermissions$.next(action?.entities)
      })
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'general.specialEvents',
        url: '/role-permissions',
        titleName: [
          'general.specialEvents',
          'rolePermissionsModule.rolePermissions'
        ]
      })
    )
  }
  public addTileRow() {
    this.onClickCreateTile$.next(true)
  }
  public onClickSelectedType(type: string) {
    this.form.controls.selectedType.patchValue(type)
    if (type == 'role-permissions') {
      this.store.dispatch(
        BreadCrumbActions.initHistory({
          pageName: 'general.specialEvents',
          url: '/role-permissions',
          titleName: [
            'general.specialEvents',
            'rolePermissionsModule.rolePermissions'
          ]
        })
      )
      this.hideCreateRoleButton = false
      this.removeSearchTerm$.next(true)
      this.searchTerm = null
      this.page = 1
      this.fetchRolePermissions()
    }
    if (type == 'tiles') {
      this.store.dispatch(
        BreadCrumbActions.initHistory({
          pageName: 'general.specialEvents',
          url: '/role-permissions',
          titleName: ['general.specialEvents', 'shopModule.shopTiles']
        })
      )
      this.hideCreateRoleButton = true
    }
  }

  public onClickRow(rolePermissions: RolePermissions) {
    this.rolePermissionsService.showModal = true
    const modalRef = this.modalService.show(GenericMainWrapperModalComponent, {
      initialState: {
        navItems: getNavItems(
          String(rolePermissions.id),
          {
            fullAccess: this.rolePermissionsModuleConfig.isActive,
            isActive: this.rolePermissionsModuleConfig.isActive
          },
          NavItemType.ROLE_PERMISSION
        ),
        actions: rolePermissionsActions,
        entity: rolePermissions,
        selectIdRouteParam$: this.store.select(
          rolePermissionsSelectors.selectIdRouteParam
        ),
        moduleConfigIsActive: this.rolePermissionsModuleConfig.isActive,
        entities$: this.store.select(rolePermissionsSelectors.selectEntities),
        modalRoute: 'modal-role',
        service: this.rolePermissionsService,
        type: NavItemType.ROLE_PERMISSION,
        defaultDescription: 'rolePermissionsModule.editRolePermissions',
        ariaLabelKey: 'wcag.rolePermissionsMenu'
      },
      class: 'modal-lg modal-dialog-scrollable modal-dialog-centered'
    })

    modalRef.onHide.pipe(take(1)).subscribe((modal) => {
      this.rolePermissionsService.showModal = false
    })
  }

  public onClickCreate() {
    this.router.navigate(['/role-permissions/create'])
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      bulkActionEvent.items.forEach((i) =>
        this.store.dispatch(rolePermissionsActions.deleteOne({ id: i.id }))
      )
    }
  }
  private fetchRolePermissions() {
    if (!this.searchTerm) {
      this.store.dispatch(
        rolePermissionsActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            join: [{ field: 'role' }, { field: 'product' }],
            sort: { field: this.field, order: this.order }
          })
        })
      )
    } else {
      this.store.dispatch(
        rolePermissionsActions.fetchMany({
          params: RequestQueryBuilder.create({
            page: this.page,
            limit: this.limit,
            search: {
              $or: [
                {
                  'role.description': {
                    [CondOperator.CONTAINS_LOW]: this.searchTerm
                  }
                },
                {
                  'product.description': {
                    [CondOperator.CONTAINS_LOW]: this.searchTerm
                  }
                }
              ]
            },
            join: [{ field: 'role' }, { field: 'product' }],
            sort: { field: this.field, order: this.order }
          })
        })
      )
    }
  }
  public onSorted(fieldSort) {
    this.order = this.order == 'ASC' ? 'DESC' : 'ASC'
    if (fieldSort == 'productId') {
      fieldSort = 'product.description'
    }
    if (fieldSort == 'roleId') {
      fieldSort = 'role.description'
    }
    this.field = fieldSort
    this.page = 1

    this.fetchRolePermissions()
  }
  public selectNewPage(page) {
    this.page = page
    this.fetchRolePermissions()
  }
  public selectNewLimit(limit) {
    this.limit = limit
    this.page = 1
    this.removeSearchTerm$.next(true)
    this.fetchRolePermissions()
  }
  public onSearchTerm(searchTerm) {
    if (searchTerm.length > 0) {
      this.searchTerm$.next(searchTerm)
    } else {
      this.searchTerm = null
      this.page = 1
      this.fetchRolePermissions()
    }
  }
}
